module.exports = __webpack_public_path__ + "img/hotel4.1287361d.png";